import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const initRefund = (tokens: any, userAccessToken: string, req: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.InitiateRefund,
    method: 'POST',
    config: sitConfig(tokens),
    body: req,
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { initRefund }
